import React from 'react';
import { IIncident } from '../../interfaces';
import * as FormUI from '../../../pageForm/FormUI';
import { formColumnsWidth } from '../../../pageForm/PageHeadersWidthConfig';
import GeneralFormItem from '../../../../components/GeneralFormItem';
import FormCreator from '../../../pageForm/FormCreator';
import { IncidentType } from '../../../../components/IncidentType';
import formatEventDates from './formatIncidentDates';
import { parseIncidentDescription } from '../../../../components/Incidents/utils';
import ActionsMenu from '../../../../components/ActionsMenu';
import { SingleSelectOption } from '../../../../components/Dropdown/SingleSelect';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import { useAppDispatch } from '../../../../redux/hooks';

interface IProps {
  incident: IIncident;
  onDeleteClick: () => void;
}

const IncidentRow = ({ incident, onDeleteClick }: IProps) => {
  const dispatch = useAppDispatch();

  const { start, end, type, name, description, creator } = incident;

  const descriptionText = parseIncidentDescription(description);

  const handleUpdateIncident = () => {
    dispatch(
      openModal({
        type: ModalSliceType.EditCalendarIncident,
        data: incident,
      }),
    );
  };

  return (
    <FormUI.Row $gridTemplateColumns={formColumnsWidth.incidents}>
      <GeneralFormItem label={name} tooltipContent={name} isBold />
      {descriptionText ? (
        <GeneralFormItem
          label={descriptionText}
          tooltipContent={descriptionText}
        />
      ) : (
        <div />
      )}
      <FormCreator label={creator.name} picture={creator.picture} />
      <IncidentType name={type.name} />
      <FormUI.DataLabel $isRightAligned>
        {formatEventDates(start, end)}
      </FormUI.DataLabel>
      <FormUI.ActionsContainer>
        <ActionsMenu>
          <SingleSelectOption
            iconName="pencil"
            label={'Edit'}
            onClick={handleUpdateIncident}
          />
          <SingleSelectOption
            iconName="trash"
            label={'Delete'}
            onClick={onDeleteClick}
          />
        </ActionsMenu>
      </FormUI.ActionsContainer>
    </FormUI.Row>
  );
};

export default IncidentRow;
